import { render, staticRenderFns } from "./Boating.vue?vue&type=template&id=340993a2&scoped=true&"
import script from "./Boating.vue?vue&type=script&lang=js&"
export * from "./Boating.vue?vue&type=script&lang=js&"
import style0 from "./Boating.vue?vue&type=style&index=0&id=340993a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340993a2",
  null
  
)

export default component.exports